var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdwordsTopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "AdTop",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "AdTop",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.5a.5.5 0 00.5.5H10a2 2 0 002-2V6a2 2 0 00-2-2H8.5a.5.5 0 00-.5.5v4zM11 7a1 1 0 01-1 1H9V5h1a1 1 0 011 1v1zM6.5 9a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5H6a3 3 0 00-3 3v1.5a.5.5 0 001 0V8h2v.5a.5.5 0 00.5.5zM6 5v2H4a2 2 0 012-2z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1a1 1 0 00-1 1v9a1 1 0 001 1h13a1 1 0 001-1V2a1 1 0 00-1-1H1zm1 9V3h11v7H2z",
    shapeRendering: "geometricPrecision"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0 2a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgAdwordsTopIcon;